import { createContext } from 'react';

interface Props {}

const ApplicationContext = createContext<Props>({});

export { ApplicationContext };
